<template>
  <main role="Komplain">
    <div class="row">
      <KomplainTable />
    </div>
  </main>
</template>

<script>
import KomplainTable from "../Komplain/KomplainTable";
export default {
  components: {
    KomplainTable,
  },
};
</script>

<style>
.modal-content {
  background-color: rgb(245, 245, 245);
}
</style>